var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.purchReceipt, rules: _vm.rules }
    },
    [
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("验收单信息")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-4" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("收货单")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "recvVoucherNo",
                    rules: { validator: _vm.checkNullModel, trigger: "change" }
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x bottom-line",
                    attrs: { disabled: "", type: "text" },
                    model: {
                      value: _vm.purchReceipt.recvVoucherNo,
                      callback: function($$v) {
                        _vm.$set(_vm.purchReceipt, "recvVoucherNo", $$v)
                      },
                      expression: "purchReceipt.recvVoucherNo"
                    }
                  }),
                  _vm._v(" "),
                  _vm.recvVoucherId == null
                    ? _c("div", {
                        staticClass:
                          "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                        attrs: { title: "选择" },
                        on: {
                          click: function($event) {
                            _vm.selectRecvVoucher()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("标题")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.purchReceipt.title || "无"))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("收货日期")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.purchReceipt.recvDate))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("交易单号")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.purchReceipt.tradeNo))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("订单编号")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.purchReceipt.orderNo))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("卖家")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.purchReceipt.sellerName))])
          ])
        ]),
        _vm._v(" "),
        _vm.showBizUnitWarehouse
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("入库仓库")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "warehouseId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: true },
                          model: {
                            value: _vm.warehouseId,
                            callback: function($$v) {
                              _vm.warehouseId = $$v
                            },
                            expression: "warehouseId"
                          }
                        },
                        _vm._l(_vm.warehouseList, function(item) {
                          return _c("el-option", {
                            attrs: { label: item.name, value: item.id }
                          })
                        })
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v(" ")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "autoReceive" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.changeAutoReceive },
                      model: {
                        value: _vm.purchReceipt.autoReceive,
                        callback: function($$v) {
                          _vm.$set(_vm.purchReceipt, "autoReceive", $$v)
                        },
                        expression: "purchReceipt.autoReceive"
                      }
                    },
                    [_vm._v("机构负责人自动领用")]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("验收条目")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small",
              on: {
                click: function($event) {
                  _vm.selectRecvItems()
                }
              }
            },
            [_vm._v("选择商品")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small swb-btn-primary",
              on: {
                click: function($event) {
                  _vm.refreshQuantity()
                }
              }
            },
            [_vm._v("刷新数量")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-layout" }, [
        _vm.purchReceipt.itemList != null &&
        _vm.purchReceipt.itemList.length > 0
          ? _c(
              "div",
              [
                _c("div", { staticClass: "simple-row" }, [
                  _c("div", { staticClass: "right" }, [
                    _vm.purchReceipt.itemList != null
                      ? _c("span", [
                          _vm._v(
                            "已选择(" +
                              _vm._s(_vm.purchReceipt.itemList.length) +
                              ")"
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.purchReceipt.itemList,
                      border: "",
                      "tooltip-effect": "dark",
                      maxHeight: "400"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "goodsTitle",
                        label: "商品名称",
                        width: "200",
                        fixed: "left",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "catName",
                        label: "分类",
                        width: "100",
                        fixed: "left",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "brandName",
                        label: "品牌",
                        width: "100",
                        fixed: "left",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "model",
                        label: "型号",
                        width: "150",
                        fixed: "left",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "fixedSpec",
                        label: "规格",
                        width: "150",
                        fixed: "left",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "tmpNo",
                        label: "系统编号",
                        width: "240"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "recvQuantity",
                        width: "80",
                        label: "收货数量"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "exchgSumQuantity",
                        width: "95",
                        label: "已换货数量"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "returnSumQuantity",
                        width: "95",
                        label: "已退货数量"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "assetCheckedQuantity",
                        width: "95",
                        label: "已验收数量"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "quantity",
                        width: "100",
                        label: "本次验收数量"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("el-input", {
                                attrs: { type: "text", disabled: "" },
                                on: {
                                  change: function($event) {
                                    _vm.quantityChange(rows.row)
                                  }
                                },
                                model: {
                                  value: rows.row.quantity,
                                  callback: function($$v) {
                                    _vm.$set(rows.row, "quantity", $$v)
                                  },
                                  expression: "rows.row.quantity"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "unit",
                        "min-width": "50",
                        label: "单位"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "taxRate",
                        align: "right",
                        width: "100",
                        label: "税率(%)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s((rows.row.taxRate || 0).toFixed(2))
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "ntxPrice",
                        align: "right",
                        width: "100",
                        label: "未税单价(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.ntxPrice != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.ntxPrice.toFixed(2)))
                                  ])
                                : _c("span", [_vm._v("0.00")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "wtxPrice",
                        align: "right",
                        width: "100",
                        label: "含税单价(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.wtxPrice != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.wtxPrice.toFixed(2)))
                                  ])
                                : _c("span", [_vm._v("0.00")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "taxOffset",
                        align: "center",
                        width: "90",
                        label: "购置可抵税"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.taxOffset
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v("是")
                                  ])
                                : _c("span", [_vm._v("否")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "invoiceState",
                        width: "100",
                        label: "开票状态"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.invoiceStateMap[rows.row.invoiceState]
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "invoiceType",
                        width: "130",
                        label: "发票类型"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.invoiceTypeMap[rows.row.invoiceType]
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "assetType",
                        width: "130",
                        label: "管理方式"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.assetTypeMap[rows.row.assetType])
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "customized",
                        align: "center",
                        width: "90",
                        label: "是否定制"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(rows.row.customized ? "是" : "否")
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "100",
                        label: "操作",
                        fixed: "right"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.removeGoods(rows.$index)
                                    }
                                  }
                                },
                                [_vm._v("移除")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b115fae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b115fae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/receipt/PurchReceiptSave.vue
// module id = 2993
// module chunks = 0